import classNames from "classnames";
import {Link, useLocation} from "react-router-dom";
import React, {CSSProperties, useState} from "react";
import {appPages} from "../App";
import {ReactComponent as Orders} from "./orders.svg"

export function Menu() {
    const [menuCSS, setMenuCSS] = useState<CSSProperties | undefined>(undefined);
    const location = useLocation()

    return <nav className="sidebar hide-scrollbar width-adaptive-wider overflow-visible flexbox mobile-friendly"
                id={"ozon-main-menu-1"}>
        <nav className="sidebar-mobile-toggle">
            <div
                className="box align-center"
                onClick={() => {
                    if (menuCSS) {
                        setMenuCSS(undefined)
                    } else {
                        setMenuCSS({display: "block"})
                    }
                }}
            >
                <i className="fas fa-bars"/> Меню
            </div>
        </nav>
        <main style={menuCSS} className="sidebar-body hide-scrollbar" id="wa-app-navigation">
            <ul className="menu with-icons">
                <li className={classNames({selected: location.pathname === '/'})}>
                    <Link to={"/"}>
                        <i className={classNames("custom-mr-4", "fas fa-folder")}/>Настройки API
                    </Link>
                </li>
                <li className={classNames({
                    selected: [
                        appPages.selectProducts,
                        appPages.categoriesComparison,
                        appPages.generalOfferAttributes,
                        appPages.offerAttributes,
                        appPages.offersExport,
                        appPages.exportHistory
                    ].includes(location.pathname)
                })}>
                    <Link to={appPages.selectProducts}>
                        <i className={classNames("custom-mr-4", "fas fa-solid fa-file-export")}/>Экспорт
                        товаров
                    </Link>
                    <ul className={'menu'} style={{marginLeft:'15px'}}>
                        <li className={classNames({selected: location.pathname === appPages.selectProducts})}>
                            <Link to={appPages.selectProducts}>1. Выбор товаров</Link></li>
                        <li className={classNames({selected: location.pathname === appPages.categoriesComparison})}>
                            <Link to={appPages.categoriesComparison}>2. Сопоставление категорий</Link></li>
                        <li className={classNames({selected: location.pathname === appPages.generalOfferAttributes})}>
                            <Link to={appPages.generalOfferAttributes}>3. Настройка общих характеристик</Link>
                        </li>
                        <li className={classNames({selected: location.pathname === appPages.offerAttributes})}>
                            <Link to={appPages.offerAttributes}>4. Сопоставление характеристик</Link></li>
                        <li className={classNames({selected: location.pathname === appPages.offersExport})}>
                            <Link to={appPages.offersExport}>5. Экспорт товаров</Link></li>
                        <li className={classNames({selected: location.pathname === appPages.exportHistory})}>
                            <Link to={appPages.exportHistory}>6. Статус экспорта</Link></li>
                    </ul>
                </li>
                <li className={classNames({
                    selected: [
                        appPages.stockSync,
                        appPages.stocksHistory
                    ].includes(location.pathname)})}>
                    <Link to={appPages.stockSync}>
                        <i className={classNames("custom-mr-4", "fa fa-sync")}/>Обновление остатков
                    </Link>
                    {/*<ul className={'menu'} style={{marginLeft:'15px'}}>*/}
                        {/*<li className={classNames({selected: location.pathname === appPages.stocksHistory})}>*/}
                            {/*<Link to={appPages.stocksHistory}>История обновлений</Link></li>*/}
                    {/*</ul>*/}
                </li>
                <li className={classNames({ selected: [
                        appPages.priceSync,
                        appPages.priceSync  + '/launcher/',
                        appPages.priceSync  + '/history/',
                        appPages.priceSync  + '/history/product/:product_id',
                    ].includes(location.pathname)})}>
                    <Link to={appPages.priceSync}>
                        <i className={classNames("custom-mr-4", "fa fa-sync")}/>Обновление цен
                    </Link>
                </li>
                <li className={classNames({selected: location.pathname === appPages.ordersSync})}>
                    <Link to={appPages.ordersSync}>
                        <Orders style={{marginRight: '5px'}}/>Синхронизация заказов
                    </Link>
                </li>
                <li className={classNames({selected: location.pathname === appPages.exportDebug})}>
                    <Link to={appPages.exportDebug}>
                        <i className={classNames("custom-mr-4", "fa fa-wrench")}/>Проверка данных
                    </Link>
                </li>
            </ul>
        </main>
    </nav>
}